var ccConfig = {
  showConsoleLog: true,
  enableDataLayerEvents: true,
  position: 'bottom-left',
  theme: 'dark',
  cookie: {
    name: 'cookieconsent_status_v3',
  },
  content: {
    infoLinkHref: '/cookieverklaring/',
    infoLinkTarget: '_self',
  },
  // blacklistPage: ['/cookieverklaring/'],

  onInitialise: function (state, status) {},
  onStatusChange: function (state, status, chosenBefore) {
    // DATALAYER
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'cookieMelding',
      consent: state.grantedCategories.join(),
    });
  },
  onPopupOpen: function (state, status) {},
  onPopupClose: function (state) {},
};

function getScriptParams() {
  var currentScript = document.getElementById('ccpopup-js-init');
  return {
    version: currentScript.getAttribute('data-version'),
  };
}

(function (d, s, id) {
  var js,
    ccjs = d.getElementsByTagName(s)[0];
  if (d.getElementById(id)) return;
  js = document.createElement(s);
  js.id = id;
  js.defer = 'true';
  js.src = 'https://cf.creativesuspects.io/cc/3.0/cookieconsent.nl.min.js?cdv=' + getScriptParams().version;
  ccjs.parentNode.insertBefore(js, ccjs);
})(document, 'script', 'ccpopup-js');
